import Vue from 'vue'

export default {
    getMonitordata(params){
        //return Vue.prototype.$axios.get("/base/Monitor/gatedata", {params})
        return Vue.prototype.$axios.get("api/v1/results/GetByKey", {params})
    },
    getWeather(params){
        return Vue.prototype.$axios.get("https://api.open.geovisearth.com/weather/v1/fixed_point_forecast", {params})
    }
}